import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { DecorationSet } from '@tiptap/pm/view';

// Extension to handle {{survey.link}} replacement
export const SurveyLinkReplacement = Extension.create({
  name: 'surveyLinkReplacement',

  addOptions() {
    return {
      initialSurveyId: null,
    };
  },

  addProseMirrorPlugins() {
    const initialSurveyId = this.options.initialSurveyId;

    return [
      new Plugin({
        key: new PluginKey('surveyLinkReplacement'),

        state: {
          init() {
            return DecorationSet.empty;
          },
          apply(tr, oldDecoSet) {
            return oldDecoSet.map(tr.mapping, tr.doc);
          },
        },

        appendTransaction(transactions, oldState, newState) {
          const docChanged = transactions.some((tr) => tr.docChanged);
          if (!docChanged) return null;

          const { doc, tr } = newState;
          let modified = false;

          // Search for {{survey.link}} pattern in the document
          doc.descendants((node, pos) => {
            if (node.isText) {
              const text = node.text || '';
              const regex = /\{\{survey\.link\}\}/g;
              let match;

              while ((match = regex.exec(text)) !== null) {
                const from = pos + match.index;
                const to = from + match[0].length;

                // Replace the text with survey component, using initialSurveyId if available
                tr.delete(from, to);
                tr.insert(
                  from,
                  newState.schema.nodes.surveySelect.create({
                    surveyId: initialSurveyId ?? null,
                  })
                );

                modified = true;
              }
            }
          });

          return modified ? tr : null;
        },
      }),
    ];
  },
});
